import c from './colors';
import { ThemeParameters } from './types';
import { setAlpha } from './utils';

/**
 * @see http://livingston.sas.com/10-0/display/text/
 *
 * TODO: see how much of this overlaps with the font design tokens.
 */
export const textTokens = {
  basic(theme: ThemeParameters) {
    let fg;
    switch (theme.baseThemeName) {
      case 'high-contrast':
      case 'dark':
        fg = c.white(theme);
        break;
      default:
        fg = c.n_3(theme);
    }

    return { fg, fontSize: '0.875rem', lineHeight: 1.3 };
  },

  description(theme: ThemeParameters) {
    let fg;
    switch (theme.baseThemeName) {
      case 'high-contrast':
        fg = c.white(theme);
        break;
      case 'dark':
        fg = c.white80(theme);
        break;
      default:
        fg = c.n_1(theme);
    }

    return { fg, fontSize: '0.75rem', lineHeight: 1.3 };
  },

  descriptionDisabled(theme: ThemeParameters) {
    let fg;
    switch (theme.baseThemeName) {
      case 'high-contrast':
        fg = c.white(theme);
        break;
      case 'dark':
        fg = setAlpha(c.white(theme), 0.25);
        break;
      default:
        fg = setAlpha(c.white(theme), 0.3);
    }

    return { fg, fontSize: '0.75rem', lineHeight: 1.3 };
  },

  unread(theme: ThemeParameters) {
    let fg;
    switch (theme.baseThemeName) {
      case 'high-contrast':
      case 'dark':
        fg = c.white(theme);
        break;
      default:
        fg = c.n_3(theme);
    }

    return { fg, fontSize: '0.875rem', fontWeight: 'bold', lineHeight: 1.3 };
  },

  highlighted(theme: ThemeParameters) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return { fg: c.black(theme), bg: c.white(theme) };
    }
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return { fg: c.black(theme), bg: c.w1_5(theme) };
      case 'dark':
        return { fg: c.p_3(theme), bg: '#877BD5' };
      default:
        return { fg: c.white(theme), bg: '#7668CF' };
    }
  },

  highlightedInFocus(theme: ThemeParameters) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return { fg: c.black(theme), bg: c.white(theme) };
    }
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return { fg: c.black(theme), bg: c.w1_5(theme) };
      case 'dark':
        return { fg: c.p_3(theme), bg: '#AEA6E3' };
      default:
        return { fg: c.white(theme), bg: '#4F3DC2' };
    }
  },

  selection(theme: ThemeParameters) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: setAlpha(c.white(theme), 0.99), // setting an alpha value other than 1 prevents Chrome from lowering the opacity
        };
      case 'dark':
        return { fg: c.white(theme), bg: setAlpha(c.p1(theme), 0.99) };
      default:
        return { fg: c.white(theme), bg: setAlpha(c.p(theme), 0.99) };
    }
  },
};

// TextToken NOVA
export const textTokensNova = {
  // Use 0.99 alpha to prevent webkit browsers from applying their own alpha value
  selection(theme: ThemeParameters) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return { fg: c.colorTextInverse(theme), bg: setAlpha(c.colorPrimary(theme), 0.99) };
      case 'dark':
        return { fg: c.colorTextDefault(theme), bg: setAlpha(c.colorPrimary(theme), 0.99) };
      default:
        return { fg: c.colorTextInverse(theme), bg: setAlpha(c.colorPrimary(theme), 0.99) };
    }
  },
};
